/* dn-cart-waisen.js — Sets ohne Designs: an der Tuer anhalten, im Warenkorb herausnehmen (DE, 2026-10-12).

   Warum: ein Set mit Designwahl geht als EINE Elternzeile in den Warenkorb, die Designs stehen in
   `_childItemsJson`, und die Cart-Transform-Funktion der Custom-App macht daraus die Kinderzeilen
   der Bestellung. Liegt die Elternzeile ohne diese Eigenschaft im Warenkorb, bezahlt die Kundin das
   Set und bekommt keine Designs (#DN1502169, 2026-09-27). Gemessen ueber alle Bestellungen seit
   2026-09-01: 19 solche Faelle im Online Store, alle ohne jede Eigenschaft, also nie ueber ein
   Formular oder Skript des Themes gelaufen (das stempelt seit 2026-08-25 `_shopify_source` an jede
   Zeile), die meisten mit Landung auf /cart von shopify.com aus: Warenkoerbe, die Shopify selbst
   anlegt (Kundenkonto "Erneut kaufen", Warenkorb-Links). Die Produktseite kann das nicht verhindern.

   Zwei Aufgaben:

   1. Tuer: ein gewoehnlicher Formular-Submit eines Sets (theme.js ProductForm schickt dann nur die
      Varianten-ID) wird angehalten, wenn die gewaehlte Variante eine Set-Variante ist. Merker im
      Formular: snippets/dn-set-marker.liquid listet die Varianten mit custom.free_nails_in_set_variant
      > 0 (data-dn-set-varianten). Nicht .inventory-product: die Klasse traegt in product-form.liquid
      auch die Geschenkkarte (2026-10-13). Betrifft Schnellansicht, die
      klebende Leiste des Themes, Karten mit Direkt-Kauf und die Produktseite, wenn das Chooser-Skript
      (custom-nsd-inv-*.js) nicht gebunden ist. Die Chooser schicken ihre Zeilen per fetch und laufen
      hier nicht durch. Capture am document laeuft vor dem submit-Zuhoerer des Formulars.

   2. Warenkorb: snippets/dn-cart-waisen.liquid rendert im <cart-drawer> die Liste der Waisen als
      JSON (Variante mit custom.free_nails_in_set_variant > 0, ohne oder mit leerem _childItemsJson,
      ohne item_components). Dieses
      Skript nimmt die Zeilen NACHEINANDER per /cart/change.js heraus (parallele change.js verlieren
      Aenderungen, siehe dn-cart.js), zeichnet die Schublade ueber den Weg des Themes neu
      (dnCartNeuZeichnen aus dn-cart.js, sonst cart:updated + cart:refresh, damit Blase und
      Geschenk-Automatik mitziehen) und zeigt unter dem Kopf der Schublade einen Hinweis mit Link zur
      Set-Seite, bis die Schublade geschlossen wird. Laeuft beim Laden der Seite (die Schublade ist
      serverseitig gerendert, auch auf /?open_cart=true, wohin /cart umleitet) und nach jedem
      Neuzeichnen (childList am <cart-drawer>: _rerenderCart und dnCartNeuZeichnen tauschen innerHTML).
      Ein Durchgang laeuft nie doppelt (laeuft); jeder Schluessel wird nur EINMAL versucht (versucht),
      sonst liefe ein dauerhaft scheiterndes change.js mit dem Neuzeichnen im Kreis.

   3. Gesperrte Produkte (2026-10-20): Zeilen mit "grund":"gesperrt" (Tag hide_or_remove_from_cart,
      siehe snippets/dn-cart-waisen.liquid) laufen durch denselben Ablauf, Hinweis ohne Link. Sie
      duerfen wiederkommen (Kundin legt nochmal rein), deshalb eigener Zaehler (versuchtGesperrt):
      jede Eingabe der Kundin (pointerdown, keydown) setzt ihn zurueck, ohne Eingabe hoechstens 3
      Runden. Das Tag gehoert nie auf Geschenk-, Pflicht- oder Set-Produkte: die Geschenk-Automatik
      legt sie nach jedem Neuzeichnen ohne Eingabe zurueck, nach 3 Runden bleiben sie liegen.

   Texte je Sprache: window.dnSetText aus sections/mini-cart.liquid (DE, EN, FR, IT, NL).

   Sichtbar fuer uns: console.warn und, wenn Sentry geladen ist, eine Meldung je Fall. So sieht man,
   wie oft und von welchem Set solche Zeilen noch kommen. */
(function () {
  if (window.dnWaisenReady) return;
  window.dnWaisenReady = true;

  function text(schluessel, titel) {
    return window.dnSetText ? window.dnSetText(schluessel, titel) : '';
  }

  function melden(text) {
    try { console.warn('dn-cart-waisen: ' + text); } catch (e) {}
    try {
      if (window.Sentry && typeof window.Sentry.captureMessage === 'function') {
        window.Sentry.captureMessage('dn-cart-waisen: ' + text, 'warning');
      }
    } catch (e) {}
  }

  /* ---------- 1) Tuer: Formular-Submit eines Sets ohne Designs ---------- */
  function setMerker(form) {
    if (!form || !form.matches || !form.matches('form[is="product-form"]')) return null;
    var merker = form.querySelector('[data-dn-set-produkt]');
    if (!merker) return null;
    /* gewaehlte Variante: Feld "id" im Formular (auch per form=-Attribut aussen, z. B. klebende Leiste) */
    var feld = form.elements ? form.elements.namedItem('id') : null;
    var variante = feld && feld.value ? String(feld.value) : '';
    var liste = merker.getAttribute('data-dn-set-varianten') || '';
    if (variante && liste.indexOf(',' + variante + ',') === -1) return null;
    return merker;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var merker = setMerker(form);
    if (!merker) return;
    var feld = form.querySelector('input[name="properties[_childItemsJson]"]');
    if (feld && feld.value && feld.value.replace(/[\[\]\s"]/g, '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    melden('Formular-Submit eines Sets ohne Designs angehalten: ' + (merker.getAttribute('data-dn-set-produkt') || form.id || ''));
    form.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true,
      cancelable: true,
      detail: { status: 'error', error: text('tuer') || 'Dieses Set braucht deine Designauswahl. Bitte wähle deine Designs auf der Set-Seite und lege es dann in den Warenkorb.' }
    }));
  }, true);

  /* ---------- 2) Warenkorb: Waisen herausnehmen ---------- */
  var laeuft = false;
  var hinweise = [];
  var versucht = {};
  var versuchtGesperrt = {};
  ['pointerdown', 'keydown'].forEach(function (typ) {
    document.addEventListener(typ, function () { versuchtGesperrt = {}; }, true);
  });

  function drawer() { return document.getElementById('mini-cart'); }

  function lesen() {
    var d = drawer();
    var el = d && d.querySelector('[data-dn-waisen]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function entfernen(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function neuZeichnen() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        if (!cart || typeof cart !== 'object') return;
        if (typeof window.dnCartNeuZeichnen === 'function') return window.dnCartNeuZeichnen(cart);
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      });
  }

  function hinweiseWeg() {
    hinweise = [];
    var d = drawer();
    if (!d) return;
    var alte = d.querySelectorAll('.dn-waisen-hinweis');
    for (var i = 0; i < alte.length; i++) alte[i].parentNode.removeChild(alte[i]);
  }

  function zeigen() {
    var d = drawer();
    if (!d || !hinweise.length) return;
    var kopf = d.querySelector('.drawer__header');
    hinweise.forEach(function (h) {
      if (d.querySelector('.dn-waisen-hinweis[data-dn-handle="' + h.handle + '"]')) return;
      var box = document.createElement('div');
      box.className = 'dn-waisen-hinweis';
      box.setAttribute('role', 'status');
      box.setAttribute('data-dn-handle', h.handle);
      var text = document.createElement('p');
      text.textContent = h.text;
      box.appendChild(text);
      if (h.url) {
        var link = document.createElement('a');
        link.href = h.url;
        link.textContent = h.link;
        box.appendChild(link);
      }
      if (kopf && kopf.parentNode) kopf.parentNode.insertBefore(box, kopf.nextSibling);
      else d.appendChild(box);
    });
  }

  function pruefen() {
    if (laeuft) return;
    var daten = lesen();
    var zeilen = (daten && daten.zeilen ? daten.zeilen : []).filter(function (z) {
      if (!z || !z.key) return false;
      return z.grund === 'gesperrt' ? (versuchtGesperrt[z.key] || 0) < 3 : !versucht[z.key];
    });
    if (!zeilen.length) { zeigen(); return; }
    laeuft = true;
    zeilen.reduce(function (p, z) {
      return p.then(function () {
        var gesperrt = z.grund === 'gesperrt';
        if (gesperrt) versuchtGesperrt[z.key] = (versuchtGesperrt[z.key] || 0) + 1;
        else versucht[z.key] = true;
        var was = gesperrt ? 'Gesperrtes Produkt' : 'Set ohne Designs';
        return entfernen(z.key).then(function (ok) {
          if (!ok) { melden(was + ' konnte nicht entfernt werden: ' + z.handle); return; }
          melden(was + ' aus dem Warenkorb entfernt: ' + z.handle);
          if (!hinweise.some(function (h) { return h.handle === z.handle; })) {
            hinweise.push(gesperrt
              ? { handle: z.handle, text: text('gesperrt', z.titel) }
              : { handle: z.handle, url: z.url, link: text('link'), text: text('entfernt', z.titel) });
          }
        });
      });
    }, Promise.resolve())
      .then(neuZeichnen)
      .then(function () { laeuft = false; zeigen(); })
      .catch(function () { laeuft = false; });
  }

  /* Neuzeichnen (innerHTML-Tausch am <cart-drawer>) und Schliessen (open-Attribut) erkennen */
  function beobachten() {
    var d = drawer();
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function (liste) {
      var neu = false;
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].type === 'attributes') {
          if (!d.hasAttribute('open')) hinweiseWeg();
        } else if (liste[i].type === 'childList') {
          neu = true;
        }
      }
      if (neu) pruefen();
    }).observe(d, { childList: true, attributes: true, attributeFilter: ['open'] });
  }

  function start() {
    if (!drawer()) return;
    beobachten();
    pruefen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
